module.exports = __webpack_public_path__ + "img/bsjd.f788d1d8.png";